import { render, staticRenderFns } from "./AhReviews.vue?vue&type=template&id=dda32c04&scoped=true&lang=pug&"
import script from "./AhReviews.vue?vue&type=script&lang=js&"
export * from "./AhReviews.vue?vue&type=script&lang=js&"
import style0 from "./AhReviews.vue?vue&type=style&index=0&id=dda32c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda32c04",
  null
  
)

export default component.exports